export default function offset(el) {
    const rect = el.getBoundingClientRect();
    const scrollLeft = window.scrollX;
    const scrollTop = window.scrollY;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
}
